import React, { useContext } from 'react';
import { AdminContext } from '../../context/AdminContext';
import ChooseBackground from '../../functions/chooseBackground';
import AppIcons from '../../icons';
import styles from './styles.module.css';
import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';
import Avatar from '../Avatar';
import SHARED from '../../constants';

export default function ChatDemo({ content }) {
  const { bg, backScale } = useContext(AdminContext);
  return (
    <div
      className={` ${styles.container} rtl  `}
      // style={{ backgroundSize: `${SHARED.maxBgScale * backScale}` }}
    >
      <div
        // className={`${styles.content} ${
        //   ChooseBackground(bg)?.repeat ? 'repeatBg' : 'noRepeatBg'
        // }`}
        className={`${styles.content} `}
        style={{
          //   backgroundImage: `url(${ChooseBackground(bg)?.src})`,
          //   backgroundSize: ChooseBackground(bg)?.cover
          //     ? 'cover'
          //     : `${SHARED.maxBgScale * backScale}px`,
          position: 'relative',
        }}
      >
        <div
          className={` ${styles.absoluteBg} darkMode  ${
            ChooseBackground(bg)?.repeat ? 'repeatBg' : 'noRepeatBg'
          }`}
          style={{
            backgroundImage: `url(${ChooseBackground(bg)?.src})`,
            // backgroundSize: '200px',
            // backgroundSize: `${SHARED.maxBgScale * backScale}px`,
            backgroundSize: ChooseBackground(bg)?.cover
              ? 'cover'
              : `${SHARED.maxBgScale * backScale}px`,
            // height: `100%`,
          }}
        ></div>
        <div className="message__chats flex-row-reverse ">
          {/* <div
            className={`flex flex-row-reverse justify-start items-center h-auto w-auto my-[5px]`}
          >
          </div> */}
          <div className="message__recipient message_recieved">
            <div
              className={`flex flex-col justify-start items-start w-auto ml-auto`}
            >
              {/* <div className={`mr-auto cursor-pointer`}>
                <p className={`text-left `}>{content?.chatDemo?.contact}</p>
              </div> */}

              <p className={`${styles.text}`}>
                {content?.chatDemo?.contactText}
              </p>

              {/* <div
                className={`flex flex-row justify-between items-center  mt-10px  w-full replyChatStyle`}
              >
                <AppIcons.replyIcon width={20} height={20} fill="#4A5568" />
              </div> */}
            </div>
          </div>
        </div>
        <div className="message__chats">
          <div
            className={`flex flex-row justify-start items-center h-auto w-auto my-[5px]`}
          >
            {/* <Avatar
              width={24}
              height={24}
              containerclassName={`cursorDefault`}
              className={`cursorDefault`}
              src={blanckUser}
              local={true}
            /> */}
          </div>
          <div className={`message__sender message_sent`}>
            <div
              className={`flex flex-col justify-start items-start w-auto ml-auto`}
            >
              <div
                className={`flex flex-row justify-between items-center w-full h-auto`}
              >
                {/* <p className="sender__name ">{content?.chatDemo?.you}</p> */}
                {/* <div className={`mr-auto cursor-pointer`}>
                  <AppIcons.closeIcon width={12} height={12} />
                </div> */}
              </div>

              <p className={`${styles.text}`}>{content?.chatDemo?.yourText}</p>

              <div
                className={`flex flex-row justify-between items-center  mt-10px  w-full replyChatStyle`}
              >
                {/* <AppIcons.seenIcon width={20} height={20} /> */}

                {/* <AppIcons.replyIcon width={20} height={20} fill="#4A5568" /> */}
              </div>
            </div>
          </div>
        </div>

        <div className="message__chats flex-row-reverse">
          <div
            className={`flex flex-row-reverse justify-start items-center h-auto w-auto my-[5px]`}
          >
            {/* <Avatar
              width={24}
              height={24}
              containerclassName={`cursorDefault`}
              className={`cursorDefault`}
              src={blanckUser}
              local={true}
            /> */}
          </div>
          <div className="message__recipient  message_recieved">
            <div
              className={`flex flex-col justify-start items-start w-auto ml-auto`}
            >
              {/* <div className={`mr-auto cursor-pointer`}>
                <p className={`text-left `}>{content?.chatDemo?.contact}</p>
              </div> */}

              <p className={`${styles.text}`}>
                {content?.chatDemo?.contactText}
              </p>

              {/* <div
                className={`flex flex-row justify-between items-center  mt-10px  w-full replyChatStyle`}
              >
                <AppIcons.replyIcon width={20} height={20} fill="#4A5568" />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
